/*
  Build Your Bundle price for the bundle page: the same maths as the "Pack prices" discount
  (bundle-sync-app supaeasy/pack-prices.template.js) for a cart holding only bundle items, so the
  page shows exactly what the cart will charge. Rules come from snippets/rb-pack-rules.liquid.
  Amounts are cents in the shopper's currency; rate is Shopify.currency.rate (1 in AUD).
  Theme asset: assets/rb-bundle-quote.js. Tested against the discount code in
  scripts/supaeasy-offers-test.ts.
*/
(function (root) {
  function roundUp(cents, ending) {
    return Math.ceil((cents - ending) / 100 - 1e-9) * 100 + ending;
  }

  function highest(tiers, qty) {
    var found = null;
    (tiers || []).forEach(function (t) { if (qty >= t.qty && (!found || t.qty > found.qty)) found = t; });
    return found;
  }

  // items: [{ productId, unit, qty }]. Returns { full, total, percent, next } in cents.
  function quote(rules, rate, items) {
    var byProduct = {};
    var units = 0;
    items.forEach(function (item) {
      if (!item.qty) return;
      var deal = null;
      rules.deals.forEach(function (d) {
        if ((d.variants || []).indexOf(String(item.variantId)) !== -1) deal = d;
      });
      if (!deal) rules.deals.forEach(function (d) { if (d.products.indexOf(String(item.productId)) !== -1) deal = d; });
      var key = deal && deal.group || item.productId;
      var g = byProduct[key] || (byProduct[key] = { qty: 0, cents: 0, deal: deal });
      g.qty += item.qty;
      g.cents += item.unit * item.qty;
      units += item.qty;
    });
    var bundleTier = highest(rules.bundle.tiers, units);
    var full = 0;
    var total = 0;
    Object.keys(byProduct).forEach(function (productId) {
      var g = byProduct[productId];
      var deal = g.deal;
      var pay = g.cents;
      var tier = deal ? highest(deal.tiers, g.qty) : null;
      if (tier) {
        var pack = tier.percent != null ? g.cents * (100 - tier.percent) / 100 : tier.price * g.qty / tier.qty * rate;
        var ending = rate === 1 ? deal.round : 0;
        pay = ending == null ? Math.round(pack) : roundUp(pack, ending);
      }
      if (bundleTier) {
        var bundle = g.cents * (100 - bundleTier.percent) / 100;
        bundle = rate === 1 ? Math.round(bundle) : roundUp(bundle, 0);
        if (bundle < pay) pay = bundle;
      }
      full += g.cents;
      total += Math.min(pay, g.cents);
    });
    var next = null;
    (rules.bundle.tiers || []).forEach(function (t) { if (t.qty > units && (!next || t.qty < next.qty)) next = t; });
    return { full: full, total: total, units: units, percent: bundleTier ? bundleTier.percent : 0, next: next };
  }

  root.RbBundleQuote = quote;
})(typeof window !== 'undefined' ? window : globalThis);
